// extracted by mini-css-extract-plugin
export default {"textfield":"CustomTextField_textfield__IBlCq","textfield__label":"CustomTextField_textfield__label__5MZef font-xs-medium"};